var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入单据号" },
                                model: {
                                  value: _vm.queryParam.billNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "billNo", $$v)
                                  },
                                  expression: "queryParam.billNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "来源类型",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    placeholder: "请选择来源类型",
                                    "allow-clear": "",
                                  },
                                  model: {
                                    value: _vm.queryParam.sourceType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "sourceType",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.sourceType",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "采购转固" } },
                                    [_vm._v("采购转固")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "领用转固" } },
                                    [_vm._v("领用转固")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "手工转固" } },
                                    [_vm._v("手工转固")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "状态",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    placeholder: "请选择状态",
                                    "allow-clear": "",
                                  },
                                  model: {
                                    value: _vm.queryParam.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "status", $$v)
                                    },
                                    expression: "queryParam.status",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "0" } },
                                    [_vm._v("未审核")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "1" } },
                                    [_vm._v("已审核")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据日期",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-range-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { format: "YYYY-MM-DD" },
                                on: { change: _vm.onDateChange },
                                model: {
                                  value: _vm.queryParam.dateRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "dateRange", $$v)
                                  },
                                  expression: "queryParam.dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "table-page-search-submitButtons",
                          staticStyle: { float: "left", overflow: "hidden" },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchQuery },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.searchReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "table-operator",
              staticStyle: { "margin-top": "5px" },
            },
            [
              _vm.btnEnableList.indexOf("1") > -1
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "plus" },
                      on: { click: _vm.openAdd },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { icon: "sync" },
                  on: { click: _vm.loadData },
                },
                [_vm._v("刷新")]
              ),
              _vm.btnEnableList.indexOf("3") > -1
                ? _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: { icon: "download" },
                      on: { click: _vm.exportExcel },
                    },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.tableData,
              loading: _vm.loading,
              pagination: false,
              scroll: _vm.tableScroll,
            },
            scopedSlots: _vm._u([
              {
                key: "billTime",
                fn: function (text) {
                  return _c("span", {}, [
                    _vm._v(_vm._s(text ? text.substring(0, 10) : "")),
                  ])
                },
              },
              {
                key: "status",
                fn: function (text) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a-tag",
                        {
                          attrs: {
                            color:
                              text === "1"
                                ? "green"
                                : text === "9"
                                ? "blue"
                                : "orange",
                          },
                        },
                        [_vm._v(_vm._s(_vm.statusText(text)))]
                      ),
                    ],
                    1
                  )
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handlePrint(record)
                            },
                          },
                        },
                        [_vm._v("打印")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      record.status === "0"
                        ? [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openEdit(record)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _vm.canAudit(_vm.billPrefix(record.billNo))
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAudit(record)
                                      },
                                    },
                                  },
                                  [_vm._v("审核")]
                                )
                              : _vm._e(),
                            _vm.canAudit(_vm.billPrefix(record.billNo))
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            _vm.canSubmitFlow(_vm.billPrefix(record.billNo))
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSubmitFlow(record)
                                      },
                                    },
                                  },
                                  [_vm._v("提交审批")]
                                )
                              : _vm._e(),
                            _vm.canSubmitFlow(_vm.billPrefix(record.billNo))
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            _c(
                              "a-popconfirm",
                              {
                                attrs: { title: "作废并删除该单据?" },
                                on: { confirm: () => _vm.handleDelete(record) },
                              },
                              [
                                _c("a", { staticStyle: { color: "red" } }, [
                                  _vm._v("作废"),
                                ]),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetail(record)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openVoucher(record)
                                  },
                                },
                              },
                              [_vm._v("凭证")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUnaudit(record)
                                  },
                                },
                              },
                              [_vm._v("反审核")]
                            ),
                            Number(record.lastDebt) > 0
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            Number(record.lastDebt) > 0
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.openPayment(record)
                                      },
                                    },
                                  },
                                  [_vm._v("付款核销")]
                                )
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                },
              },
            ]),
          }),
          _c("a-pagination", {
            staticStyle: { "margin-top": "12px", "text-align": "right" },
            attrs: {
              "show-size-changer": "",
              "show-quick-jumper": "",
              current: _vm.ipagination.current,
              "page-size": _vm.ipagination.pageSize,
              "page-size-options": _vm.ipagination.pageSizeOptions,
              total: _vm.ipagination.total,
            },
            on: {
              change: _vm.handleTableChange,
              showSizeChange: _vm.handleTableChange,
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.form.id ? "编辑转固单" : "新增转固单",
            width: 1080,
            visible: _vm.visible,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "来源类型（必选）" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "选择来源类型",
                                disabled: !!_vm.form.id,
                              },
                              on: { change: _vm.onChangeSourceType },
                              model: {
                                value: _vm.form.sourceType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "sourceType", $$v)
                                },
                                expression: "form.sourceType",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "采购转固" } },
                                [_vm._v("采购转固")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "领用转固" } },
                                [_vm._v("领用转固")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "手工转固" } },
                                [_vm._v("手工转固")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.sourceType === "采购转固"
                    ? _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "供应商（必选）" } },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "选择供应商",
                                    "show-search": "",
                                    "option-filter-prop": "children",
                                  },
                                  model: {
                                    value: _vm.form.organId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "organId", $$v)
                                    },
                                    expression: "form.organId",
                                  },
                                },
                                _vm._l(_vm.supList, function (s) {
                                  return _c(
                                    "a-select-option",
                                    { key: s.id, attrs: { value: s.id } },
                                    [_vm._v(_vm._s(s.supplier))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.sourceType === "采购转固" ||
                  _vm.form.sourceType === "领用转固"
                    ? _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "来源单据" } },
                            [
                              _c("a-input-search", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  readOnly: "",
                                  placeholder: "点击选择",
                                },
                                on: { search: _vm.openSourceModal },
                                model: {
                                  value: _vm.form.sourceBillNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sourceBillNo", $$v)
                                  },
                                  expression: "form.sourceBillNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "单据日期（必填）" } },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: { format: "YYYY-MM-DD" },
                            model: {
                              value: _vm.form.billTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "billTime", $$v)
                              },
                              expression: "form.billTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "8px" } },
                [
                  _vm.form.sourceType === "手工转固"
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "plus", size: "small" },
                          on: { click: _vm.addItemRow },
                        },
                        [_vm._v("添加明细")]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    { staticStyle: { "margin-left": "12px", color: "#999" } },
                    [_vm._v("合计金额：" + _vm._s(_vm.totalAmount))]
                  ),
                ],
                1
              ),
              _c("a-table", {
                attrs: {
                  bordered: "",
                  size: "small",
                  rowKey: "_key",
                  columns: _vm.itemColumns,
                  dataSource: _vm.form.items,
                  pagination: false,
                  scroll: { x: "max-content", y: 240 },
                },
                scopedSlots: _vm._u([
                  {
                    key: "qty",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: record.qty,
                              min: 1,
                              precision: 0,
                              disabled: _vm.form.sourceType !== "手工转固",
                            },
                            on: {
                              change: (v) => _vm.onItemChange(record, "qty", v),
                            },
                          }),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "price",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: record.price,
                              min: 0,
                              precision: 2,
                              disabled: _vm.form.sourceType !== "手工转固",
                            },
                            on: {
                              change: (v) =>
                                _vm.onItemChange(record, "price", v),
                            },
                          }),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "remark",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _c("a-input", {
                            attrs: { value: record.remark },
                            on: {
                              change: (e) =>
                                _vm.onItemChange(
                                  record,
                                  "remark",
                                  e.target.value
                                ),
                            },
                          }),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "categoryId",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: record.categoryId,
                                placeholder: "选择资产类别",
                                "show-search": "",
                                "option-filter-prop": "children",
                              },
                              on: {
                                change: (v) =>
                                  _vm.onItemChange(record, "categoryId", v),
                              },
                            },
                            _vm._l(_vm.categoryOptions, function (c) {
                              return _c(
                                "a-select-option",
                                { key: c.id, attrs: { value: c.id } },
                                [_vm._v(_vm._s(c.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "materialId",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _vm.form.sourceType === "手工转固"
                            ? _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: record.materialId,
                                    placeholder: "选择物资",
                                    "show-search": "",
                                    "option-filter-prop": "children",
                                  },
                                  on: {
                                    change: (v) =>
                                      _vm.onSelectMaterial(record, v),
                                  },
                                },
                                _vm._l(_vm.materialOptions, function (m) {
                                  return _c(
                                    "a-select-option",
                                    { key: m.id, attrs: { value: m.id } },
                                    [
                                      _vm._v(
                                        _vm._s(m.name) +
                                          _vm._s(m.model ? " / " + m.model : "")
                                      ),
                                    ]
                                  )
                                }),
                                1
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(record.materialName) +
                                    _vm._s(
                                      record.materialModel
                                        ? " / " + record.materialModel
                                        : ""
                                    )
                                ),
                              ]),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _vm.form.sourceType === "手工转固"
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "删除该行?" },
                                  on: {
                                    confirm: () => _vm.removeItemRow(record),
                                  },
                                },
                                [
                                  _c("a", { staticStyle: { color: "red" } }, [
                                    _vm._v("删除"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
              _vm.form.sourceType === "采购转固"
                ? _c(
                    "a-row",
                    {
                      staticStyle: { "margin-top": "12px" },
                      attrs: { gutter: 16 },
                    },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "优惠金额" } },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: { min: 0, precision: 2 },
                                on: { change: _vm.calcDebt },
                                model: {
                                  value: _vm.form.discountMoney,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "discountMoney", $$v)
                                  },
                                  expression: "form.discountMoney",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "优惠后金额" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  value: _vm.discountLastMoney,
                                  readOnly: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "其它费用" } },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: { min: 0, precision: 2 },
                                on: { change: _vm.calcDebt },
                                model: {
                                  value: _vm.form.otherMoney,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "otherMoney", $$v)
                                  },
                                  expression: "form.otherMoney",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "支付订金" } },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: { min: 0, precision: 2 },
                                on: { change: _vm.calcDebt },
                                model: {
                                  value: _vm.form.deposit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "deposit", $$v)
                                  },
                                  expression: "form.deposit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.sourceType === "采购转固"
                ? _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "结算账户" } },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "70%" },
                                  attrs: {
                                    placeholder: "请选择结算账户",
                                    "allow-clear": "",
                                  },
                                  on: { change: _vm.onSingleAccountChange },
                                  model: {
                                    value: _vm.form.accountId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountId", $$v)
                                    },
                                    expression: "form.accountId",
                                  },
                                },
                                _vm._l(_vm.accountList, function (a) {
                                  return _c(
                                    "a-select-option",
                                    { key: a.id, attrs: { value: a.id } },
                                    [_vm._v(_vm._s(a.name))]
                                  )
                                }),
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { size: "small" },
                                  on: { click: _vm.openFormManyAccount },
                                },
                                [_vm._v("多账户")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.manyAccountStatus
                        ? _c(
                            "a-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "本次支付金额" } },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: { min: 0, precision: 2 },
                                    on: { change: _vm.calcDebt },
                                    model: {
                                      value: _vm.form.payMoney,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "payMoney", $$v)
                                      },
                                      expression: "form.payMoney",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "本次欠款" } },
                            [
                              _c("a-input", {
                                attrs: { value: _vm.debtValue, readOnly: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.sourceType === "手工转固"
                ? _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "借方科目编码（可选）" } },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "如 1601，留空走规则" },
                                model: {
                                  value: _vm.form.debitCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "debitCode", $$v)
                                  },
                                  expression: "form.debitCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "贷方科目编码（可选）" } },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "如 1002，留空走规则" },
                                model: {
                                  value: _vm.form.creditCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "creditCode", $$v)
                                  },
                                  expression: "form.creditCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              !_vm.multiOn(_vm.modalPrefix())
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              !_vm.multiOn(_vm.modalPrefix()) || !_vm.flowOn(_vm.modalPrefix())
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.saving },
                      on: { click: _vm.handleSaveAndCheck },
                    },
                    [_vm._v("保存并审核")]
                  )
                : _vm._e(),
              _vm.multiOn(_vm.modalPrefix()) && _vm.flowOn(_vm.modalPrefix())
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.saving },
                      on: { click: _vm.handleSaveAndFlow },
                    },
                    [_vm._v("保存并提交流程")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title:
              _vm.form.sourceType === "采购转固"
                ? "选择采购订单"
                : "选择资产出库单",
            width: 760,
            visible: _vm.sourceVisible,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.sourceVisible = false
            },
          },
        },
        [
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "small",
              rowKey: "id",
              columns: _vm.sourceColumns,
              dataSource: _vm.sourceRows,
              loading: _vm.sourceLoading,
              pagination: _vm.sourcePagination,
              rowSelection: {
                type: "radio",
                selectedRowKeys: _vm.sourceSelected,
                onChange: _vm.onSourceSelect,
              },
              scroll: { x: "max-content" },
            },
            on: { change: _vm.onSourcePageChange },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "12px", "text-align": "right" } },
            [
              _c(
                "a-button",
                {
                  staticStyle: { "margin-right": "8px" },
                  on: {
                    click: function ($event) {
                      _vm.sourceVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.sourceSelected.length === 0,
                  },
                  on: { click: _vm.confirmSource },
                },
                [_vm._v("加载明细")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择转固明细（已生成卡片的明细已自动排除）",
            width: 860,
            visible: _vm.itemPickVisible,
            confirmLoading: _vm.itemPickLoading,
          },
          on: {
            ok: _vm.confirmItems,
            cancel: function ($event) {
              _vm.itemPickVisible = false
            },
          },
        },
        [
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "small",
              rowKey: "id",
              columns: _vm.itemPickColumns,
              dataSource: _vm.itemPickRows,
              pagination: false,
              scroll: { x: "max-content", y: 300 },
              rowSelection: {
                selectedRowKeys: _vm.itemPickSelected,
                onChange: (keys) => (_vm.itemPickSelected = keys),
              },
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "转固单详情",
            width: 900,
            visible: _vm.detailVisible,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.detailVisible = false
            },
          },
        },
        [
          _c(
            "a-descriptions",
            { attrs: { bordered: "", size: "small", column: 2 } },
            [
              _c("a-descriptions-item", { attrs: { label: "单据号" } }, [
                _vm._v(_vm._s(_vm.detail.billNo)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "来源类型" } }, [
                _vm._v(_vm._s(_vm.detail.sourceType)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "供应商" } }, [
                _vm._v(_vm._s(_vm.detail.organName)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "来源单据" } }, [
                _vm._v(_vm._s(_vm.detail.sourceBillNo)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "单据日期" } }, [
                _vm._v(_vm._s(_vm.detail.billTime)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "合计金额" } }, [
                _vm._v(_vm._s(_vm.detail.totalAmount)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "优惠后金额" } }, [
                _vm._v(_vm._s(_vm.detail.discountLastMoney)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "其它费用" } }, [
                _vm._v(_vm._s(_vm.detail.otherMoney)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "支付订金" } }, [
                _vm._v(_vm._s(_vm.detail.deposit)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "欠款" } }, [
                _vm._v(_vm._s(_vm.detail.debt)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "剩余欠款" } }, [
                _vm._v(_vm._s(_vm.detail.lastDebt)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "状态" } }, [
                _vm._v(_vm._s(_vm.statusText(_vm.detail.status))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "借方科目" } }, [
                _vm._v(_vm._s(_vm.detail.debitSubjectText || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "贷方科目" } }, [
                _vm._v(_vm._s(_vm.detail.creditSubjectText || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "备注", span: 2 } }, [
                _vm._v(_vm._s(_vm.detail.remark)),
              ]),
            ],
            1
          ),
          _vm.detailItems.length
            ? _c("a-table", {
                staticStyle: { "margin-top": "12px" },
                attrs: {
                  bordered: "",
                  size: "small",
                  rowKey: "id",
                  columns: _vm.detailItemColumns,
                  dataSource: _vm.detailItems,
                  pagination: false,
                  scroll: { x: "max-content" },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("many-account-modal", {
        ref: "manyAccountModalForm",
        on: { ok: _vm.manyAccountOk },
      }),
      _c("asset-bill-print", { ref: "assetPrint" }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "关联凭证",
            width: 860,
            visible: _vm.voucherVisible,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.voucherVisible = false
            },
          },
        },
        [
          _vm._l(_vm.voucherRows, function (v) {
            return _c(
              "div",
              { key: v.id, staticStyle: { "margin-bottom": "16px" } },
              [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "4px", color: "#666" } },
                  [
                    _vm._v(
                      "\n        凭证字号：" +
                        _vm._s(v.voucherNo) +
                        "　日期：" +
                        _vm._s(_vm.fmtVoucherDate(v.voucherDate)) +
                        "　业务：" +
                        _vm._s(v.bizNode) +
                        "　\n        状态：" +
                        _vm._s(v.status === "1" ? "已审核" : "未审核") +
                        "\n      "
                    ),
                  ]
                ),
                _c("a-table", {
                  attrs: {
                    bordered: "",
                    size: "small",
                    rowKey: "id",
                    columns: _vm.voucherItemColumns,
                    dataSource: v.items || [],
                    pagination: false,
                    scroll: { x: "max-content" },
                  },
                }),
              ],
              1
            )
          }),
          !_vm.voucherRows.length
            ? _c("a-empty", { attrs: { description: "暂无凭证" } })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }